import React, { useState } from "react";
import ColorPalette from "./ColorPalette";
import ProductSlider from "./ProductSlider";

function ColouredProducts() {
  const [activecolor, setActiveColor] = useState("Blue");
  return (
    <div>
      <ColorPalette setActiveColor={setActiveColor} />
      <ProductSlider key={activecolor} activeColor={activecolor} />
    </div>
  );
}

export default ColouredProducts;
